var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 20.0771V20.4938L20.2961 20.7872L23.0002 23.4682V23.5387H1V23.4682L3.70409 20.7872L4.00002 20.4938V20.0771V12.6411C4.00002 8.41557 6.22393 5.09762 9.97877 4.21558L10.7501 4.03439V3.24208V2.23079C10.7501 1.55678 11.2993 1 12.0001 1C12.7009 1 13.2501 1.55678 13.2501 2.23079V3.24208V4.03376L14.0207 4.2154C17.7619 5.09731 20.0002 8.43133 20.0002 12.6411V20.0771ZM13.7213 27.0259C13.3731 27.6054 12.7331 28.0002 12.0001 28.0002C11.2587 28.0002 10.6208 27.6061 10.2754 27.0259H13.7213Z",
    fill: "#E7E7E7",
    stroke: "#C2CFE0",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 7.50005,
    rx: 6.00005,
    ry: 5.50005,
    fill: "#1877F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e1c50a7b666f215c02526953ab7150b9.svg";
export { ForwardRef as ReactComponent };